/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SequenceNumberForBr
 */
export interface SequenceNumberForBr {
    /**
     * 
     * @type {string}
     * @memberof SequenceNumberForBr
     */
    sequenceNumber?: string;
    /**
     * 
     * @type {SequenceNumberForBrStatusEnum}
     * @memberof SequenceNumberForBr
     */
    status?: SequenceNumberForBrStatusEnum;
}


/**
 * @export
 */
export const SequenceNumberForBrStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Excluded: 'EXCLUDED'
} as const;
export type SequenceNumberForBrStatusEnum = typeof SequenceNumberForBrStatusEnum[keyof typeof SequenceNumberForBrStatusEnum];


/**
 * Check if a given object implements the SequenceNumberForBr interface.
 */
export function instanceOfSequenceNumberForBr(value: object): value is SequenceNumberForBr {
    return true;
}

export function SequenceNumberForBrFromJSON(json: any): SequenceNumberForBr {
    return SequenceNumberForBrFromJSONTyped(json, false);
}

export function SequenceNumberForBrFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceNumberForBr {
    if (json == null) {
        return json;
    }
    return {
        
        'sequenceNumber': json['sequenceNumber'] == null ? undefined : json['sequenceNumber'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function SequenceNumberForBrToJSON(json: any): SequenceNumberForBr {
    return SequenceNumberForBrToJSONTyped(json, false);
}

export function SequenceNumberForBrToJSONTyped(value?: SequenceNumberForBr | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sequenceNumber': value['sequenceNumber'],
        'status': value['status'],
    };
}

